<template>
  <b-modal
    id="UserDisableError"
    centered
    size="lg"
    ref="UserDisableErrorModal"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header class="mx-auto">
      <h5 class="modal-title modal-title-centered">{{headerMessage}}</h5>
    </template>
    <template #default>
      <p class="modal-warning-text">
        <span v-html="message"></span>
      </p>
      <p>
        <span v-html="$store.getters.errorMessage"></span>
      </p>
    </template>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="onClose()">Close</b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "UserDisableError",

  data() {
    return {};
  },

  props: {
    headerMessage: String,
    message: String
  },
  methods: {
    onClose: function() {
        this.$bvModal.hide("activateuser");
        if (this.$refs.UserDisableErrorModal) this.$refs.UserDisableErrorModal.hide();
        else this.$bvModal.hide("UserDisableError");
    }
  }
};
</script>
<style>
.requiredinput {
  color: red;
}

.hasError label {
  color: red !important;
}

.hasError input {
  border-color: red !important;
}

.noError input {
  border-color: white !important;
}

.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}

.errorMessage {
  color: red;
  font-size: 0.8em;
  font-weight: 500;
}
</style>
